import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'mmm_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authedAxios = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const wazeUrl = (address) =>
  `https://www.waze.com/ul?q=${encodeURIComponent(address)}&navigate=yes`;

export const googleMapsUrl = (address) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}&travelmode=driving`;

export const formatJobTime = (iso) => {
  const d = new Date(iso);
  return d.toLocaleString('en-AU', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const formatJobTimeShort = (iso) => {
  const d = new Date(iso);
  return d.toLocaleString('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true });
};

export const formatJobDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString('en-AU', { weekday: 'short', day: '2-digit', month: 'short' });
};

export const DAY_LABELS = {
  mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday',
  fri: 'Friday', sat: 'Saturday', sun: 'Sunday',
};

export const FREQ_LABELS = {
  weekly: 'Weekly', fortnightly: 'Fortnightly', monthly: 'Monthly', one_off: 'One-off',
};
